import axios from 'axios';
import { Allergy, AllergyModel } from '../models/allergy';

export const getAllergiesAsync = async (): Promise<AllergyModel[]> => {
    const response = await axios.get('/api/allergy');
    return response.data;
};

export const getLatestAllergies = async (): Promise<Undefinable<Allergy[]>> => {
    const response = await axios.get(`/api/allergy/latest`);
    return response.data;
};

export const getAppointmentAllergies = async (appointmentId: number): Promise<Undefinable<Allergy[]>> => {
    const response = await axios.get(`/api/allergy/appointment/${appointmentId}`);
    return response.data;
};
